module.exports = __webpack_public_path__ + "static/invest-aff501c1d089a3fb21ece1d01ea0aec3.png";